<template>
  <div class="register-group-dropdown">
    <LineBroadcastDropdown>
      <template v-slot:trigger>
        <div v-if="Array.isArray(tagList) && tagList.length > 0" class="selected-badge-container">
          <LineBroadcastTag v-for="(tag, index) in tagList" :key="index" :tagText="tag" />
        </div>
      </template>
      <template v-slot:panel>
        <div class="target-register-group-panel">
          <LineBroadcastSearchInput @on-change="onSearch" />
          <LineBroadcastCheckbox
            class="header-checkbox"
            :checkState="isSelectedAll"
            @on-click="(checkState) => onclickCheckboxSelectAll(checkState)"
          >
            <p>ทั้งหมด</p>
          </LineBroadcastCheckbox>
          <div class="panel-divider" />
          <LineBroadcastAccordion v-for="group in viewOption" :key="group.id">
            <template v-slot:accordion-header>
              <LineBroadcastCheckbox
                class="header-checkbox"
                :checkState="selectionOption[group.id].state"
                @on-click="(checkState) => onClickCheckboxGroup(checkState, group.id)"
              >
                <p>{{ group.groupName }}</p>
              </LineBroadcastCheckbox>
            </template>
            <template v-slot:accordion-content>
              <div class="panel-accodion-content">
                <LineBroadcastCheckbox
                  v-for="subGroup in group.subGroups"
                  :key="subGroup.code"
                  :checkState="convertSubGroupCheckState(selectionOption[group.id].subGroup[subGroup.code])"
                  @on-click="(checkState) => onClickCheckboxSubGroup(checkState, group.id, subGroup.code)"
                >
                  <p>{{ subGroup.code }} {{ subGroup.name }}</p>
                </LineBroadcastCheckbox>
              </div>
            </template>
          </LineBroadcastAccordion>
        </div>
      </template>
    </LineBroadcastDropdown>
  </div>
</template>
<script>
import LineBroadcastAccordion from '../../../Accordion/Broadcast/Line/LineBroadcastAccordion.vue';
import LineBroadcastTag from '../../../Tag/Broadcast/Line/LineBroadcastTag.vue';
import LineBroadcastCheckbox from '../../../Checkbox/Broadcast/Line/LineBroadcastCheckbox.vue';
import LineBroadcastDropdown from '../../../Dropdown/Broadcast/Line/LineBroadcastDropdown.vue';
import LineBroadcastSearchInput from '../../../SearchInput/Broadcast/Line/LineBroadcastSearchInput.vue';
import SMMRegisterGroups from '../../../../utiles/constants/SMMregisterGroup.json';
import CHECK_STATUS_ENUM from '../../../Checkbox/CheckboxStateEnum.json';

export default {
  name: 'RegisterGroupDropdown',
  components: {
    LineBroadcastAccordion,
    LineBroadcastTag,
    LineBroadcastCheckbox,
    LineBroadcastDropdown,
    LineBroadcastSearchInput,
  },
  props: {
    /** selectedRegisterSubGroups is array of sub-group code string ex: ["0101", "0201"] */
    selectedRegisterSubGroups: {
      type: Array,
      default: () => [],
      required: true,
    },
  },
  data() {
    return {
      allSubGroupIds: [],
      isSelectedAll: CHECK_STATUS_ENUM.UNCHECK,
      selectionOption: {},
      viewOption: SMMRegisterGroups,
      selectedSubGroupList: this.selectedRegisterSubGroups,
    };
  },
  computed: {
    tagList() {
      return this.convertSelectionToTag();
    },
  },
  methods: {
    initialSelectionOption() {
      for (const smmGroup of SMMRegisterGroups) {
        const subGroupsCode = smmGroup.subGroups.map((s) => s.code);
        this.allSubGroupIds.push(...subGroupsCode);
      }
      this.setAllSelectionOptionFromSelectedSubGroupIDs(this.selectedRegisterSubGroups);
    },
    setAllSelectionOptionFromSelectedSubGroupIDs(subGroupIDs) {
      const selectedSubGroupList = [];
      for (const smmGroup of SMMRegisterGroups) {
        this.$set(this.selectionOption, smmGroup.id, {
          groupName: smmGroup.groupName,
          state: CHECK_STATUS_ENUM.CHECKED,
          subGroup: {},
        });

        let countSelectedSubGroupsInCurrentGroup = 0;
        for (const smmSubGroup of smmGroup.subGroups) {
          this.$set(this.selectionOption[smmGroup.id].subGroup, smmSubGroup.code, true);
          const isSelectedCurrentSubGroup = subGroupIDs.includes(smmSubGroup.code);
          this.$set(this.selectionOption[smmGroup.id].subGroup, smmSubGroup.code, isSelectedCurrentSubGroup);
          if (isSelectedCurrentSubGroup) {
            countSelectedSubGroupsInCurrentGroup += 1;
            selectedSubGroupList.push(smmSubGroup.code);
          }
        }

        let currentGroupDataCheckState = CHECK_STATUS_ENUM.UNCHECK;
        if (countSelectedSubGroupsInCurrentGroup > 0) {
          if (countSelectedSubGroupsInCurrentGroup === smmGroup.subGroups.length) {
            currentGroupDataCheckState = CHECK_STATUS_ENUM.CHECKED;
          } else {
            currentGroupDataCheckState = CHECK_STATUS_ENUM.CHECKED_SOME;
          }
        }
        this.selectionOption[smmGroup.id].state = currentGroupDataCheckState;
      }

      const isSelectedAll = subGroupIDs.length === this.allSubGroupIds.length;
      this.selectedSubGroupList = selectedSubGroupList;
      this.isSelectedAll = isSelectedAll ? CHECK_STATUS_ENUM.CHECKED : CHECK_STATUS_ENUM.UNCHECK;
    },
    convertSelectionToTag() {
      const tags = [];
      for (const selected of Object.keys(this.selectionOption)) {
        let checkCount = 0;
        if (this.selectionOption[selected].state !== CHECK_STATUS_ENUM.UNCHECK) {
          for (const value of Object.values(this.selectionOption[selected].subGroup)) {
            if (value) {
              checkCount += 1;
            }
          }
        }
        if (checkCount > 0) {
          tags.push(`${this.selectionOption[selected].groupName}(${checkCount})`);
        }
      }

      return tags;
    },
    convertSubGroupCheckState(isSelected) {
      if (isSelected) {
        return CHECK_STATUS_ENUM.CHECKED;
      }
      return CHECK_STATUS_ENUM.UNCHECK;
    },
    onclickCheckboxSelectAll(checkState) {
      const selectedSubGroupList = checkState === CHECK_STATUS_ENUM.CHECKED ? this.allSubGroupIds : [];
      this.setAllSelectionOptionFromSelectedSubGroupIDs(selectedSubGroupList);
    },
    onClickCheckboxGroup(checkState, groupID) {
      const subGroupCodeList = Object.keys(this.selectionOption[groupID].subGroup);
      if (checkState === CHECK_STATUS_ENUM.CHECKED) {
        this.selectedSubGroupList.push(...subGroupCodeList);
      } else {
        this.selectedSubGroupList = this.selectedSubGroupList.filter((code) => !subGroupCodeList.includes(code));
      }
      this.setAllSelectionOptionFromSelectedSubGroupIDs(this.selectedSubGroupList);
    },
    onClickCheckboxSubGroup(checkState, groupID, subGroupCode) {
      if (checkState === CHECK_STATUS_ENUM.CHECKED) {
        this.selectedSubGroupList.push(subGroupCode);
      } else {
        this.selectedSubGroupList = this.selectedSubGroupList.filter((code) => code !== subGroupCode);
      }
      this.setAllSelectionOptionFromSelectedSubGroupIDs(this.selectedSubGroupList);
    },
    onSearch(keyword) {
      if (keyword === '') {
        this.viewOption = SMMRegisterGroups;
        return;
      }

      const shouldUpdateViewOption = [];
      for (const smmGroup of SMMRegisterGroups) {
        const currentGroupViewOption = {
          id: smmGroup.id,
          groupName: smmGroup.groupName,
          subGroups: [],
        };
        for (const smmSubGroup of smmGroup.subGroups) {
          if (smmSubGroup.code.includes(keyword) || smmSubGroup.name.includes(keyword)) {
            currentGroupViewOption.subGroups.push(smmSubGroup);
          }
        }
        if (
          currentGroupViewOption.subGroups.length > 0 || currentGroupViewOption.id.includes(keyword) || currentGroupViewOption.groupName.includes(keyword)
        ) shouldUpdateViewOption.push(currentGroupViewOption);
      }
      this.viewOption = shouldUpdateViewOption;
    },
  },
  beforeMount() {
    this.initialSelectionOption();
  },
  watch: {
    selectedSubGroupList(changedSelectedSubGroupList) {
      this.$emit('change', changedSelectedSubGroupList);
    }
  }
};
</script>
<style lang="scss" scoped>
.register-group-dropdown {
  display: flex;
  flex-direction: column;
  width: 100%;
  p {
    margin-bottom: 0;
  }
  .selected-badge-container {
    display: flex;
    gap: 4px;
    flex-wrap: wrap;
  }
  .target-register-group-panel {
    padding: 12px 16px;
    display: flex;
    flex-direction: column;
    gap: 10px;
    .panel-divider {
      height: 2px;
      width: 100%;
      background-color: #dadce4;
    }
    .header-checkbox {
      padding-block: 8px;
    }
    .panel-accodion-content {
      display: flex;
      flex-direction: column;
      gap: 16px;
      padding: 8px 12px 8px 28px;
    }
  }
}
</style>
